import Instance from "../../../../Axios";

// New Actions for the app

const GetGraficoObrasMes= () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/obras/graficoObrasMes`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_GRAFICO_OBRAS_MES", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetGraficoObrasMes;